import React from 'react';
import openPopup from '../services/popupDisplay';
import '../styles/minute.css';

const Legislation = () => {
    const property = "https://www.legislation.gov.uk/ukpga/Geo5/15-16/20";
    const mortgage = "https://www.legislation.gov.uk/ukpga/1939/71/contents/enacted";
    const agriculture = "https://www.legislation.gov.uk/ukpga/1976/80";
    const rent = "https://www.legislation.gov.uk/ukpga/1977/42";
    const protection = "https://www.legislation.gov.uk/ukpga/1977/43/part/I";
    const limitation = "https://www.legislation.gov.uk/ukpga/1980/58/part/I/crossheading/actions-in-respect-of-latent-damage-not-involving-personal-injuries";
    const inheritanceTax = "https://www.legislation.gov.uk/ukpga/1984/51";
    const inheritance = "https://www.legislation.gov.uk/ukpga/1975/63";
    const housing = "https://www.legislation.gov.uk/ukpga/1988/50/part/I/chapter/III";
    const schedule3 = "https://www.legislation.gov.uk/ukpga/1988/50/schedule/3";
    const cpr55 = "https://www.justice.gov.uk/courts/procedure-rules/civil/rules/part55#55.7";
    const civil = "https://www.legislation.gov.uk/uksi/1998/3132/part/55";
    const disability = "https://www.legislation.gov.uk/ukpga/1995/50";
    const harassment = "https://www.legislation.gov.uk/ukpga/1997/40";
    const rights = "https://www.legislation.gov.uk/ukpga/1998/42";
    const trusts = "https://www.legislation.gov.uk/ukpga/1996/47/part/I/crossheading/right-of-beneficiaries-to-occupy-trust-land";
    const registration = "https://www.legislation.gov.uk/ukpga/2002/9";
    const fraud = "https://www.legislation.gov.uk/ukpga/2006/35";
    const equality = "https://www.legislation.gov.uk/ukpga/2010/15/section/13";
    const slavery = "https://www.legislation.gov.uk/ukpga/2015/30/section/3/enacted";

    return (
        <div className="justified-text">
            <h5>Relevant national legislation</h5>
            <p>
                There are several relevant legislative acts
            </p>
            <ul>
                <li><a href={property} target="_blank" rel="noopener noreferrer">Law of Property Act 1925</a></li>
                <li><a href={mortgage} target="_blank" rel="noopener noreferrer">Rent and Mortgage Interest Restrictions Act 1939</a></li>
                <li><a href={inheritance} target="_blank" rel="noopener noreferrer">Inheritance (Provision for Family and Dependants) Act 1975</a></li>
                <li><a href={agriculture} target="_blank" rel="noopener noreferrer">Rent (Agriculture) Act 1976</a></li>
                <li><a href={rent} target="_blank" rel="noopener noreferrer">Rent Act 1977</a></li>
                <li><a href={protection} target="_blank" rel="noopener noreferrer">Protection from Eviction Act 1977</a></li>
                <li><a href={limitation} target="_blank" rel="noopener noreferrer">Limitation Act 1980</a></li>
                <li><a href={inheritanceTax} target="_blank" rel="noopener noreferrer">Inheritance Tax Act 1984</a></li>
                <li><a href={housing} target="_blank" rel="noopener noreferrer">Housing Act 1988</a></li>
                <li><a href={disability} target="_blank" rel="noopener noreferrer">Disability Discrimination Act 1995</a></li>
                <li><a href={trusts} target="_blank" rel="noopener noreferrer">Trusts of Land and Appointment of Trustees Act 1996</a></li>
                <li><a href={harassment} target="_blank" rel="noopener noreferrer">Protection from Harassment Act 1997</a></li>
                <li><a href={civil} target="_blank" rel="noopener noreferrer">Civil Procedure Rules 1998</a></li>
                <li><a href={rights} target="_blank" rel="noopener noreferrer">Human Rights Act 1998</a></li>
                <li><a href={registration} target="_blank" rel="noopener noreferrer">Land Registration Act 2002</a></li>
                <li><a href={fraud} target="_blank" rel="noopener noreferrer">Fraud Act 2006</a></li>
                <li><a href={equality} target="_blank" rel="noopener noreferrer">Equality Act 2010</a></li>
                <li><a href={slavery} target="_blank" rel="noopener noreferrer">Modern Slavery Act 2015</a></li>
            </ul>
        </div>
    );
};

export default Legislation;

